/* eslint-disable max-classes-per-file */
import { Action } from '@ngrx/store';

import { User } from '../../models';

export const LOAD_USER = '[User] Load data';
export const LOAD_USER_SUCCESS = '[User] Load success';
export const LOAD_USER_FAIL = '[User] Load fail';
export const CREATE_NEW_USER = '[Auth] Create new user';
export const CREATE_NEW_USER_SUCCESS = '[Auth] Create new user success';
export const CREATE_NEW_USER_FAIL = '[Auth] Create new user fail';
export const UPDATE_USER_DATA = '[User] Update user data';
export const UPDATE_USER_DATA_SUCCESS = '[User] Update user data success';
export const UPDATE_USER_DATA_FAIL = '[User] Update user data fail';

export class LoadUser implements Action {
  readonly type = LOAD_USER;
}

export class LoadUserSuccess implements Action {
  readonly type = LOAD_USER_SUCCESS;
  constructor(public payload: User) {}
}

export class LoadUserFail implements Action {
  readonly type = LOAD_USER_FAIL;
  constructor(public payload: any) {}
}

export class CreateNewUser implements Action {
  readonly type = CREATE_NEW_USER;
  constructor(public payload: any) {}
}

export class CreateNewUserSuccess implements Action {
  readonly type = CREATE_NEW_USER_SUCCESS;
}

export class CreateNewUserFail implements Action {
  readonly type = CREATE_NEW_USER_FAIL;
  constructor(public payload: { errorMsg: string }) {}
}

export class UpdateUserData implements Action {
  readonly type = UPDATE_USER_DATA;
  constructor(public payload: User) {}
}

export class UpdateUserSuccess implements Action {
  readonly type = UPDATE_USER_DATA_SUCCESS;
  constructor(public payload: User) {}
}

export class UpdateUserDataFail implements Action {
  readonly type = UPDATE_USER_DATA_FAIL;
  constructor(public payload: any) {}
}

export type UserAction =
  | LoadUser
  | LoadUserSuccess
  | LoadUserFail
  | CreateNewUser
  | CreateNewUserSuccess
  | CreateNewUserFail
  | UpdateUserData
  | UpdateUserSuccess
  | UpdateUserDataFail;
